/**
 * @file Validation based on the customer status. These statuses are what
 *   appears in Setup > Sales > Customer Statuses
 */
import { z } from "zod";
import { createCustomSettings } from "@rootreeweb/zod-to-elements";
export const leadStatus = z
    .union([z.literal("LEAD-Lead"), z.literal("PROSPECT-Prospect")])
    .describe(createCustomSettings({ label: "Customer Status" }));
export const customerStatus = z.union([
    z.literal("CUSTOMER-Active"),
    z.literal("CUSTOMER-Lost"),
    z.literal("CUSTOMER-Loyalist"),
    z.literal("CUSTOMER-Needs Attention"),
    z.literal("CUSTOMER-New"),
    z.literal("CUSTOMER-Potential Loyalist"),
]);
export const allLeadStatuses = z.union([leadStatus, customerStatus]);
//# sourceMappingURL=lead-status-list.js.map